import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import CTAButton from "@/components/atoms/buttons/CTAButton";
import HtmlText from "@/sections/common/HtmlText";
import RevealOnScroll from "@/components/common/RevealOnScroll";

import { ITextButton } from "../../components/atoms/buttons/types";

// ------------------------------------------------------------------------------------

export type ICommonCtaSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  description?: ReactNode;
  buttons?: ITextButton[];
};

const CommonCtaSection: FC<ICommonCtaSectionProps> = (props) => {
  const { heading, description, buttons, className, ...other } = props;

  return (
    <section
      className={clsx("container py-14 md:py-20 xl:py-24", className)}
      {...other}
    >
      <RevealOnScroll>
        <div className="items-center justify-between gap-8 rounded-2xl bg-primary-950 p-8 lg:flex lg:p-12">
          {(heading || description) && (
            <div className="md:mr-10 xl:mr-16">
              {heading && (
                <p className="mb-4 block font-bricolage-grotesque text-h7 font-medium text-white lg:mb-6 lg:text-h4 xl:text-h3">
                  {heading}
                </p>
              )}
              {description && (
                <HtmlText className="prose-headings:text-white prose-p:text-white prose-strong:text-white prose-li:!text-white">
                  {description}
                </HtmlText>
              )}
            </div>
          )}

          {buttons && (
            <div className="mt-6 flex shrink-0 flex-col gap-4 sm:flex-row lg:mt-0 lg:flex-col xl:flex-row">
              {buttons?.map((button) => (
                <CTAButton
                  key={button.text}
                  id={button.id}
                  variant={button.variant}
                  radius={button.radius}
                  href={button.link}
                  target={button.target}
                  showIcon
                  iconType="arrow"
                >
                  {button.text}
                </CTAButton>
              ))}
            </div>
          )}
        </div>
      </RevealOnScroll>
    </section>
  );
};

export default CommonCtaSection;
